import React, { useEffect, useState } from "react";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import './KRAEntryScreen.css'
import * as SubStateDB from '../../Services/WeightageDB';
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import * as AccountDB from '../../Services/AccountsDB';
import * as ProcessDB from '../../Services/ProcessDB';
import * as ProfileDB from '../../Services/EmployeeDB';
import { AccountsVM, EmployeeTeamVM, KRADataVM, ProcessesVM, SubStateVM, WeightageVM } from "../../Models/ViewModels";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { Button, Input, Pagination } from "rsuite";
import { map } from "rsuite/esm/utils/ReactChildren";





export const KRAMtdDisplay=() =>{
    const[loginid,setLoginid]=useState(GetUserLoginID())
    const [cachedEmployeesList, setCachedEmployeesList] = useState(new Array<KRADataVM>())
    const [filteredList, setFilteredList] = useState(new Array<KRADataVM>())
    const [accountList, setAccountList] =useState(new Array<AccountsVM>())


  useEffect(() => {
  getAllEntryList(loginid);
  getEmployeeMTDSisplay(loginid);
   
  },[])
  const getAllEntryList = (loginid:any) => {
    AccountDB.GetKRAList(loginid).then(res => {
      if (res.data) {
        setCachedEmployeesList(res.data)
      
      };
    }).catch(err => {
      console.log("fail")
    })
  }
  const getEmployeeMTDSisplay = (loginid:any) => {
    AccountDB.GetProdCount(loginid).then(res => {
      if (res.data) {
        setFilteredList(res.data)
        
      };
    }).catch(err => {
      console.log("fail")
    })
  }
  
  return (
  
    <div id="class" >
      <table id="tab1">
        <tr>
          <th>ID</th>
          <th>Designation</th>
          <th>Reporting To</th>
          <th>Shift</th>
          <th>MTD Production Rating</th>
          <th>MTD Production %</th>
          <th>Year-Month</th>
           </tr>                
        {
                    filteredList.length>0&&filteredList.map(sub=>{

                        if(sub===null)  
                        return<></>
                        else 
                       
                        return(
                          <tr>
                          <td>{sub.EmployeeOfficeBadgeId}</td>
                          <td>{sub.Designation}</td>
                          <td>{sub.ReportingOfficer}</td>
                          <td>{sub.Shift}</td>
                 

                          <td>{(sub.TotalProductionCount/sub.Date)==0||(sub.TotalProductionCount/sub.Date)<=84?
                           1:  
           ((sub.TotalProductionCount/sub.Date)>=85&&(sub.TotalProductionCount/sub.Date)<=94?
            2:
           ((sub.TotalProductionCount/sub.Date)>=95&&(sub.TotalProductionCount/sub.Date)<=99?3: ((sub.TotalProductionCount/sub.Date)>=100&&(sub.TotalProductionCount/sub.Date)<=104?4:5)))}</td>
               
          <td>{sub.BaseAttendance==null?Math.round((sub.TotalProductionCount/sub.Date)* 100) / 100:
        ((sub.LOP+sub.ApprovedLeave>2)?Math.round((sub.TotalProductionCount/(sub.BaseAttendance-sub.EligibleAttendance))):
        (sub.TotalProductionCount/(sub.FullPresent))).toFixed(2)}</td>

                          <td>{sub.Year}</td></tr>
                    )}
                    )

          }
        
      </table>
       </div>
  );
  
      }
         
        